import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../../helpers/custom-prop-types';
const ProfessionalUnitProjectCareerTitle = (props) => {
    const { title } = props;
    return (_jsx("div", Object.assign({ className: 'project_career_title' }, { children: _jsx("h5", Object.assign({ className: 'title_text' }, { children: title })) })));
};
ProfessionalUnitProjectCareerTitle.propTypes = {
    title: propStr().isRequired,
};
export default ProfessionalUnitProjectCareerTitle;
